var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVlTraslation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03125 8.5C5.64983 5.29564 8.82483 5.00001 11.9999 5C15.175 4.99999 18.3501 5.29562 17.9688 8.5C17.3989 13.2876 16.8 19 12.6737 19H11.3263C7.2 19 6.60113 13.2876 6.03125 8.5Z",
    fill: "#C9D2D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70033 20.714L5.99995 22.0001L2.00001 22.0001L2 18.0417L3.27874 19.3071L9.29291 13.293L10.7071 14.7072L4.70033 20.714Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 5.95844L21.9999 2L18 2.00003L19.2997 3.28624L16.793 5.79297L18.2072 7.20719L20.7213 4.69307L21.9999 5.95844Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlTraslation);
export default __webpack_public_path__ + "static/media/VL-traslation.59dec3ec.svg";
export { ForwardRef as ReactComponent };